import React from 'react';
import { Text } from 'react-native';
import { LocStr } from '../../../../utils/Utils';
import { textPrimary_14_0 } from './TextStyle';

const LargeTextWithSpecialFont = ({
  globJSON, simPlatform, language, txt,
}) => (
  <Text style={[textPrimary_14_0(globJSON, simPlatform), {
    width: 240,
    height: 22,
    textAlign: 'center',
  }]}
  >
    {LocStr(txt, language)}
  </Text>
);
export default LargeTextWithSpecialFont;
